import React, {Component} from 'react';
import './App.css';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import axios from "axios";
import $ from 'jquery';
import ReactGA from "react-ga";
import {addLocaleData, IntlProvider} from "react-intl";
import locale_en from "react-intl/locale-data/en";
import locale_ja from "react-intl/locale-data/ja";

import messages_ja from "./languages/ja.json";
import messages_en from "./languages/en.json";

import AdminRoot from './components/Admin/AdminRoot/AdminRoot';
import SiteRoot from './components/Site/SiteRoot/SiteRoot';
import {BASE_URL, RESOURCE_BASE_URL, WS_BASE_URL} from "./configuration";
import {loadReCaptcha} from 'react-recaptcha-google';
import Authenticate from "./components/Common/Authenticate/Authenticate";
import {addResponseMessage, Chat} from "react-chat-popup";
import logo from './logo.svg';
import InitialQuotationState from "./components/Site/QuotationForm/InitialQuotationState";
import Footer from "./components/Site/HomeContent/HomeContent";
import GoogleAds from "./components/Common/GoogleAds/GoogleAds";
import ScrollUpButton from "react-scroll-up-button";
import Draggable from 'react-draggable';
import Login from "./components/Site/Login/Login";

addLocaleData([...locale_en, ...locale_ja]);

const translations = {
    'ja': messages_ja,
    'en': messages_en
};

var stompClient = null;
const uuidv4 = require('uuid/v4');

class App extends Component {


    constructor(props) {
        super(props);

        this.state = {
            'locale': 'ja',
            loggedIn: false,
            userId: null,
            isAdmin: false,
            cartItems: [],
            roles: [],
            userName: null,
            inChatWith: 'ADMIN-ANY',
            isStompClientConnected: false,
            intervalId: -1,
            offlineUserId: null,
            user: null
        };

        // this.authenticate = this.authenticate.bind(this);
        this.getCartItems = this.getCartItems.bind(this);
        this.getCartItemsLocal = this.getCartItemsLocal.bind(this);
        this.getLoggedUser = this.getLoggedUser.bind(this);
        this.getUserRole = this.getUserRole.bind(this);
        this.removeOfflineUser = this.removeOfflineUser.bind(this);
        this.launchAddToCart = this.launchAddToCart.bind(this);
        this.getUserID = this.getUserID.bind(this);
        this.authenticate = this.authenticate.bind(this);
        this.initializeRequestHeaders = this.initializeRequestHeaders.bind(this);
        //this.getTokenInvalidation = this.getTokenInvalidation.bind(this);
    }


    connect = (userName) => {
        if (userName && !this.state.isStompClientConnected) {
            this.setState({
                username: userName
            });
            const Stomp = require('stompjs');
            var SockJS = require('sockjs-client');
            SockJS = new SockJS(WS_BASE_URL + "ws");
            stompClient = Stomp.over(SockJS);
            stompClient.connect({}, this.onConnected, this.onError);
        }
    };

    onConnected = () => {

        this.setState({
            isStompClientConnected: true
        });
        clearInterval(this.state.intervalId);

        let userName = "";
        if (this.state.userName === null) {
            userName = localStorage.getItem("userName");
        } else {
            userName = this.getCookie("username");
        }

        // Subscribing to chat
        stompClient.subscribe('/kitcut/chat', this.onMessageReceived);
        // Registering user to server
        console.log("===============> userName onConnected:" + this.state.userName);
        stompClient.send("/app/addUser",
            {},
            JSON.stringify({sender: userName, type: 'JOIN'})
        )
        var chatMessage = {
            sender: userName,
            receiver: this.state.inChatWith,
            content: "",
            type: "CHAT"
        };
        setTimeout(() => {
            stompClient.send("/app/sendMessage", {}, JSON.stringify(chatMessage));
        }, 1000)
    };

    disconnect = () => {
        let userName = "";
        if (this.state.userName === null) {
            userName = localStorage.getItem("userName");
        } else {
            userName = this.getCookie("username");
        }
        if (stompClient != null) {
            stompClient.send("/app/removeUser",
                {},
                JSON.stringify({sender: userName, type: 'JOIN'})
            );
//            document.cookie = "username=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            stompClient.disconnect();
        }
        console.log("Disconnected...");
    };

    setupBeforeUnloadListener = () => {
        window.addEventListener("beforeunload", (ev) => {
//                ev.preventDefault();
            return this.disconnect();
        });
    };

    onError = (error) => {
        // setInterval(this.connect(this.state.userName), 60000);
        // setTimeout(this.connect(userName), 60000);
        // clearInterval(this.state.intervalId);

        let userName = "";
        if (this.state.userName === null) {
            userName = localStorage.getItem("userName");
        } else {
            userName = this.getCookie("username");
        }

        if (this.state.intervalId !== -1) {
            clearInterval(this.state.intervalId);
        }
        let intervalId = setInterval(() => {
            this.connect(userName);
        }, 5000);
        this.setState({intervalId: intervalId});
    };


    sendMessage = (type, value) => {

        let userName = "";
        if (this.state.userName === null) {
            userName = localStorage.getItem("userName");
        } else {
            userName = this.getCookie("username");
        }

        if (stompClient && this.state.isStompClientConnected) {
            var chatMessage = {
                sender: userName,
                receiver: this.state.inChatWith,
                content: value,
                type: type
            };
            console.log("inside of the sendMessage" + userName);
            setTimeout(() => {
                stompClient.send("/app/sendMessage", {}, JSON.stringify(chatMessage));
            }, 1500)
        } else {
            this.connect(userName);
        }
    };

    removeOfflineUser = (userId) => {

        this.setState({
            offlineUserId: userId
        })

    };

    setCookie = (cname, cvalue, exdays) => {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    getCookie = (cname) => {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    onMessageReceived = (payload) => {
        let userName = "";
        if (this.state.userName === null) {
            userName = localStorage.getItem("userName");
        } else {
            userName = this.getCookie("username");
        }
        // let userName = this.state.userName;
        let messageList = JSON.parse(payload.body);
        if (messageList.length > 0) {

            messageList.map((msg) => {
                if (msg.type == "LEAVE") {
                    // this.removeOfflineUser(msg.sender);
                } else {
                }
            })
        }

        if (messageList.length > 1) {
            messageList.map((message) => {
                if (message.receiver === userName || message.sender === userName) {
                    addResponseMessage(message.content ? message.content : "");
                }
            });
        } else {
            if (messageList.receiver === userName) {
                addResponseMessage(messageList.content ? messageList.content : "");
                if (this.state.inChatWith === 'ADMIN-ANY') {
                    this.state.inChatWith = messageList.sender;
                }
            }
        }
    };

    handleNewUserMessage = (newMessage) => {
        this.sendMessage('CHAT', newMessage);
    };


    componentDidMount() {

        if (localStorage.getItem("logStatus") !== null) {
            this.getTokenInvalidation();
        }

        localStorage.removeItem("oi");
        this.authenticate();
        // if(localStorage.getItem("pc") === "pc"){
        //     console.log("LOGIN TAB ONLOAD ====> ");
        //     localStorage.setItem("pc", "no");
        // }

        // localStorage.removeItem("oi");
        // this.authenticate();

        loadReCaptcha();
        addResponseMessage("ご不明な点はございますか？\n" +
            "チャットでお答えします。\n\n\n " +
            "[受付時間]\n\n\n" +
            "営業日 / 営業時間：\n\n(月曜日から金曜日)\n\n" +
            "10：00　～　17：00　\n\n" +
            "土曜・日曜・祝祭日・弊社指定休日を除く");
        this.setupBeforeUnloadListener();
    }

    componentWillUnmount() {
        sessionStorage.setItem("a", 'logout');

    }

    getCartItems = () => {

        if (this.state.user != null) {
            this.getCartItemsLocal();
        }
    };

    getLoggedUser = (userId) => {
        // console.log("App.js RENDERED GET LOGGED USER METHOD=====>", this.state.userId);
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        // axios.get(RESOURCE_BASE_URL + 'api/users/' + userId, axiosConfig)
        axios.get(RESOURCE_BASE_URL + 'api/users/' + this.state.userId, axiosConfig)
            .then((res) => {
                console.log("getUser details ===> ", res.data);
                if (res.data.userRole === "ADMIN") {

                    this.setState({
                        isAdmin: true
                    })
                }
                InitialQuotationState.loggedUserId = this.state.userId;

                this.setState({
                    user: res.data
                }, () => {
                    // if (InitialQuotationState.naviUserName === "" || InitialQuotationState.naviUserName === null) {
                    if (InitialQuotationState.naviUserName === "" || InitialQuotationState.naviUserName === null || InitialQuotationState.naviUserName === undefined) {
                        // InitialQuotationState.naviUserName = res.data.username;
                        this.getLoggedUser(userId);
                    }

                    InitialQuotationState.naviUserName = res.data.username;
                    console.log("Navi user name ==> " + InitialQuotationState.naviUserName);
                    console.log("Navi userName ==> " + res.data.username);

                    // InitialQuotationState.naviUserName=res.data.username;
                    // this.launchAddToCart(res.data.id);
                })
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    };

    getCartItemsLocal = () => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        axios.get(RESOURCE_BASE_URL + 'api/users/' + this.state.userId + '/cart/items', axiosConfig)
            .then((res) => {
                this.setState({
                    cartItems: res.data
                });
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    };

    launchAddToCart = (userId) => {

        if (localStorage.getItem("ci") !== null && userId !== undefined) {
            let savedItem = localStorage.getItem("ci");
            let savedCartItem = JSON.parse(savedItem);

            console.log("STORAGE CART ITEM DUO ===== > ", savedCartItem);

            // localStorage.setItem("ci", null);
            let axiosConfig = {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    "Access-Control-Allow-Origin": "*",
                }
            };

            let cartResourceUrl = RESOURCE_BASE_URL + 'api/users/' + localStorage.getItem("userId") + '/cart';

            console.log("ADD TO CART REQUEST DUO APP JS ====> ", savedCartItem);

            axios.post(cartResourceUrl, savedCartItem, axiosConfig)
                .then((res) => {
                    this.getCartItemsLocal();
                    localStorage.setItem("ci", null);
                    console.log("ADD TO CART WITH LOCAL STORAGE ==== >", res.data);
                    window.location.href = BASE_URL + "cart";

                })
                .catch((err) => {
                    localStorage.setItem("ci", null);
                    console.log("[API] ERROR: ", err);
                });

        }

    };

    getUserRole = () => {

        let userRole = localStorage.getItem("userRole");
        if (userRole === "ROLE_ADMIN") {
            this.setState({isAdmin: true})
        }
    };

    getUserID = () => {
        let tokenString;
        if (localStorage.getItem("userRole") === "ROLE_IMPERSONATE") {
            tokenString = localStorage.getItem("newTokenString");
        } else {
            tokenString = localStorage.getItem("tokenString")
        }

        let axiosConfig = {
            headers: {
                'Authorization': tokenString.toString()
            }
        };
        axios.get(RESOURCE_BASE_URL + 'api/user-new', axiosConfig)
            .then((res) => {
                let userId = res.data.payload.id;
                const user = res.data.payload;
                localStorage.setItem("userName",res.data.payload.userName);
                localStorage.setItem("userId",res.data.payload.id);
                console.log("get user : ", user);

                InitialQuotationState.naviUserName = res.data.payload.userName;
                InitialQuotationState.loggedUserId = res.data.payload.id;

                this.setState({
                    user: res.data.payload,
                    userId: res.data.payload.id
                }, () => {
                    // if (InitialQuotationState.naviUserName === "" || InitialQuotationState.naviUserName === null) {
                    if (InitialQuotationState.naviUserName === "" || InitialQuotationState.naviUserName === null || InitialQuotationState.naviUserName === undefined) {
                        // InitialQuotationState.naviUserName = res.data.username;
                        // this.getLoggedUser(userId);
                        alert("should not come here");
                    }

                    if (localStorage.getItem("userRole") === "ROLE_USER") {
                        this.connect(this.state.userId);
                    }

                    console.log("get user ID", this.state.userId);

                    InitialQuotationState.naviUserName = res.data.payload.userName;
                    console.log("Navi user name ==> " + InitialQuotationState.naviUserName);
                    console.log("Navi userName ==> " + user.userName);
                    console.log("Navi userName (state) ==> " + this.state.user.userName);

                    // InitialQuotationState.naviUserName=res.data.username;
                    // this.launchAddToCart(res.data.id);
                });


                // this.setState({userId: userId, user: user});
                // console.log("get user", this.state.user);
                if (res.data.userRole === "ROLE_ADMIN") {

                    this.setState({
                        isAdmin: true
                    })
                }

                InitialQuotationState.loggedUserId = res.data.payload.userId;
                console.log("Navi user name1 ==> " + InitialQuotationState.naviUserName);
                console.log("Navi userName1 ==> " , user.userName);

            }).catch((err) => {
            console.log("Get user Id error", err);
        })
    }

    getTokenInvalidation = () => {
        let tokenString;
        if (localStorage.getItem("userRole") !== null && localStorage.getItem("userRole") === 'ROLE_IMPERSONATE') {
            tokenString = localStorage.getItem("newTokenString");
        } else {
            tokenString = localStorage.getItem("tokenString");
        }

        let axiosConfig = {
            headers: {
                'Authorization': tokenString.toString()
            }
        };

        axios.get(RESOURCE_BASE_URL + 'api/user-new', axiosConfig)
            .then((res) => {
                const user = res.data.payload;
                console.log("Token valid");

            }).catch((err) => {
            console.log("Token invalid");
            localStorage.clear();
            window.location.replace(BASE_URL + "login");
        })
    }


    authenticate = () => {

        if (localStorage.getItem("logStatus") === "logged") {
            // sessionStorage.setItem("a", "logged");
            document.cookie = "isLog=logged";

            InitialQuotationState.isLogged = true;
            this.initializeRequestHeaders();
            this.getUserID();

            let roles = "customer";
            let customerRoles = ["offline_access", "uma_authorization"];
            let customerRoles_str = JSON.stringify(customerRoles);

            let roles_str = JSON.stringify(roles);
            if (roles_str === customerRoles_str) {
                roles = "customer";
            } else if (roles_str === "admin") {
                roles = "admin";
            } else {
            }


        } else {
            InitialQuotationState.isLogged = false;

            if (this.getCookie("username") === "") {
                this.state.userName = "random-user-" + uuidv4();
                this.setCookie("username", this.state.userName, 1);
            } else {
                this.state.userName = this.getCookie("username");
            }

            this.connect(this.state.userName);

        }
        // }).error(() => console.log("ERROR"));

    };

    onLanguageChange = (locale, option) => {
        locale = locale ? "ja" : "en";

        InitialQuotationState.lang = locale;
        this.setState({
            'locale': locale
        }, () => localStorage.setItem("setLang", locale));


    };

    render() {
        let locale = this.state.locale;
        let messages = translations[locale];
        ReactGA.initialize('UA-151875767-1');
        ReactGA.pageview(window.location.pathname + window.location.search);
        return (
            <div className="app">
                <GoogleAds slot="696274611"/>
                <IntlProvider locale={locale} messages={messages}>
                    <div>
                        <div>
                            <Authenticate userData={this.state.user}
                                          roles={this.state.roles}
                                          getUserRole={this.getUserRole}
                                          // getLoggedUser={this.getLoggedUser}
                                          isAdmin={this.state.isAdmin}
                                          user={this.state.user}
                            />
                            <BrowserRouter>

                                <Switch>
                                    <Route path="/"
                                           render={(props) =>
                                               <SiteRoot {...props}
                                                         userData={this.state.user}
                                                         authenticated={this.state.loggedIn}
                                                         authenticate={this.authenticate}
                                                         onLanguageChange={this.onLanguageChange.bind(this)}
                                                         userId={this.state.userId}
                                                         isAdmin={this.state.isAdmin}
                                                         cartItems={this.state.cartItems}
                                                         getCartItems={this.getCartItems}
                                                         locale={this.state.locale}
                                               />
                                           }
                                    />

                                    {/*<Route path="/admin"*/}
                                    {/*       render={(props) =>*/}
                                    {/*           <AdminRoot {...props}*/}
                                    {/*                      userData={this.state.user}*/}
                                    {/*                      authenticated={this.state.loggedIn}*/}
                                    {/*                      authenticate={this.authenticate}*/}
                                    {/*                      onLanguageChange={this.onLanguageChange.bind(this)}*/}
                                    {/*                      userId={this.state.userId}*/}
                                    {/*                      isAdmin={this.state.isAdmin}*/}
                                    {/*                      offlineUserId={this.state.offlineUserId}*/}
                                    {/*           />*/}
                                    {/*       }*/}
                                    {/*/>*/}

                                    <Route path="/:name"
                                           render={(props) =>
                                               <SiteRoot {...props}
                                                         userData={this.state.user}
                                                         authenticated={this.state.loggedIn}
                                                         authenticate={this.authenticate}
                                                         onLanguageChange={this.onLanguageChange.bind(this)}
                                                         userId={this.state.userId}
                                                         isAdmin={this.state.isAdmin}
                                                         cartItems={this.state.cartItems}
                                                         getCartItems={this.getCartItems}
                                               />
                                           }
                                    />
                                </Switch>
                            </BrowserRouter>
                        </div>
                        {/*<div className="site-footer-div">*/}
                        {/*<Footer/>*/}
                        {/*</div>*/}

                    </div>
                </IntlProvider>

                {/*{!this.state.isAdmin && localStorage.getItem("userRole") !== "ROLE_IMPERSONATE"?
                    <div className='chat-outer-div-app' id='chat-outer-div-app'>
                        {this.state.isStompClientConnected && <Chat handleNewUserMessage={this.handleNewUserMessage}
                                                                    profileAvatar={logo}
                                                                    title="KITCUT PCBチャット相談窓口"
                                                                    subtitle=""
                                                                    senderPlaceHolder="メッセージを入力..."/>}
                    </div>
                    : ''
                }*/}

                {/*{!this.state.isAdmin ?*/}
                {/*    <Draggable*/}
                {/*        axis="y"*/}
                {/*        handle=".handle1"*/}
                {/*        defaultPosition={{x: 0, y: 0}}*/}
                {/*        position={null}*/}
                {/*        grid={[25, 25]}*/}
                {/*        scale={1}*/}
                {/*    >*/}
                {/*        <div>*/}

                {/*            <Draggable*/}
                {/*                axis="x"*/}
                {/*                handle=".handle1"*/}
                {/*                defaultPosition={{x: 0, y: 0}}*/}
                {/*                position={null}*/}
                {/*                grid={[25, 25]}*/}
                {/*                scale={1}*/}
                {/*            >*/}
                {/*                <div className={"handle1"}>*/}
                {/*                    <Chat handleNewUserMessage={this.handleNewUserMessage}*/}
                {/*                          profileAvatar={logo}*/}
                {/*                          title="KITCUT PCBチャット相談窓口"*/}
                {/*                          subtitle=""*/}
                {/*                          senderPlaceHolder="メッセージを入力..."/>*/}
                {/*                </div>*/}

                {/*            </Draggable>*/}
                {/*        </div>*/}

                {/*    </Draggable>*/}
                {/*    : ''*/}
                {/*}*/}

                {/*<Chat handleNewUserMessage={this.handleNewUserMessage}*/}
                {/*profileAvatar={logo}*/}
                {/*title="Kitcut Chat"*/}
                {/*subtitle=""/>*/}

                <div className='scroll-outer-div-app' id='scroll-outer-div-app'>
                    <ScrollUpButton
                        StopPosition={0}
                        ShowAtPosition={150}
                        EasingType='easeOutCubic'
                        AnimationDuration={500}
                        ContainerClassName='ScrollUpButton__Container'

                    />
                    <ScrollUpButton
                        StopPosition={0}
                        ShowAtPosition={150}
                        EasingType='easeOutCubic'
                        AnimationDuration={500}
                        ContainerClassName='ScrollUpButton__Container_quo'

                    />
                </div>

                {/*<Draggable*/}
                {/*    axis="y"*/}
                {/*    handle=".handle2"*/}
                {/*    defaultPosition={{x: 0, y: 0}}*/}
                {/*    position={null}*/}
                {/*    grid={[25, 25]}*/}
                {/*    scale={1}*/}
                {/*>*/}
                {/*    <div>*/}
                {/*        <Draggable*/}
                {/*            axis="x"*/}
                {/*            handle=".handle2"*/}
                {/*            defaultPosition={{x: 0, y: 0}}*/}
                {/*            position={null}*/}
                {/*            grid={[25, 25]}*/}
                {/*            scale={1}*/}
                {/*        >*/}
                {/*            <div className={"handle2"}>*/}
                {/*                <ScrollUpButton*/}
                {/*                    StopPosition={0}*/}
                {/*                    ShowAtPosition={150}*/}
                {/*                    EasingType='easeOutCubic'*/}
                {/*                    AnimationDuration={500}*/}
                {/*                    ContainerClassName='ScrollUpButton__Container'*/}

                {/*                />*/}
                {/*            </div>*/}
                {/*        </Draggable>*/}
                {/*    </div>*/}

                {/*</Draggable>*/}
            </div>

        )
            ;
    }

    initializeRequestHeaders = () => {

        if (localStorage.getItem("userRole") === "ROLE_IMPERSONATE") {
            axios.interceptors.request.use(request => {
                let tokenString = localStorage.getItem("newTokenString");
                request.headers['Authorization'] = tokenString.toString();
                request.headers['Content-Type'] = 'application/json';
                return Promise.resolve(request)
            }, error => {
                return Promise.reject(error)
            });
        } else {
            axios.interceptors.request.use(config => {
                let tokenString = localStorage.getItem("tokenString");
                config.headers['Authorization'] = tokenString.toString();
                config.headers['Content-Type'] = 'application/json';
                return Promise.resolve(config)
            }, error => {
                return Promise.reject(error)
            });
        }



        // const refreshToken = (minValidity = 5) => {
        //     return new Promise((resolve, reject) => {
        //         keycloak.updateToken(minValidity)
        //             .success(() => resolve())
        //             .error(error => reject(error))
        //     });
        // };

    }

}

export default App;



// WEBPACK FOOTER //
// ./src/App.js